import React from "react";
import { useGetQuery } from "../../store/slices/apiSlice";
import { ProgressSpinner } from "primereact/progressspinner";
import { Spinner } from "../../pages/CRUDPages/CRUDPages.styles";
import {
  Container,
  MembersList,
  Member,
  OnlineTag,
  Label,
} from "./SessionMembersList.styles";

const SessionMembersList: React.FC = () => {
  const { data, isLoading } = useGetQuery(`users/me/sessions`);

  if (isLoading)
    return (
      <Spinner>
        <ProgressSpinner />
      </Spinner>
    );

  const sessionData = data?.[0];
  if (!sessionData) return <div>Нет данных</div>;

  return (
    <Container>
      <Label>
        Максимальное количество активных пользователей:{" "}
        {sessionData.maxActiveUsers}
      </Label>
      <Label>
        Активных пользователей сейчас: {sessionData.activeUsers.length}
      </Label>

      {sessionData.activeUsers.lenght ? (
        <MembersList>
          {sessionData.activeUsers.map((user: string) => (
            <Member>
              <OnlineTag />
              <p>{user}</p>
            </Member>
          ))}
        </MembersList>
      ) : (
        <></>
      )}
    </Container>
  );
};

export default SessionMembersList;
